import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Slide from '@mui/material/Slide';
import React from 'react';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
});

const Popover = ({ title, children, handleClose, open }) => {
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            fullWidth
            maxWidth={false}
            onClose={handleClose}
            aria-describedby='alert-dialog-slide-description'
            PaperProps={{
                style: {
                    position: 'absolute',
                    bottom: 0,
                    margin: 0,
                    borderTopLeftRadius: 20,
                    borderTopRightRadius: 20,
                    width: '100%',
                },
            }}
        >
            <Grid container sx={{ borderBottom: '1px solid #E1E1E1' }} alignItems='center'>
                <Grid item xs={11}>
                    <DialogTitle>{title}</DialogTitle>
                </Grid>
                <Grid item xs={1}>
                    <DialogActions sx={{ justifyContent: 'center' }}>
                        <span onClick={handleClose} className='material-icons'>
                            close
                        </span>
                    </DialogActions>
                </Grid>
            </Grid>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pb: 2 }}>{children}</DialogContent>
        </Dialog>
    );
};

export default Popover;
